/**
 * Retailer limits constants for shopping cart operations
 */
export const RETAILER_LIMITS = Object.freeze({
  maxQuantityPerProduct: 10,
  maxProductCount: 20,
});

/**
 * Validates cart item quantities against defined limits
 * @param existingQuantity Current quantity of an item
 * @param newQuantity Quantity to add (can be negative for removal)
 * @param totalItems Current total items in the cart
 * @throws Error if limits are exceeded
 */
export const validateCartItemLimits = (
  newQuantity: number,
  totalItems: number
): void => {
  const updatedQuantity = Math.max(0, newQuantity);

  if (updatedQuantity > RETAILER_LIMITS.maxQuantityPerProduct) {
    throw new Error(
      `You can only have ${RETAILER_LIMITS.maxQuantityPerProduct} of the same product in your cart`
    );
  }

  if (totalItems > RETAILER_LIMITS.maxProductCount) {
    throw new Error(
      `You can only have ${RETAILER_LIMITS.maxProductCount} products in your cart`
    );
  }
};
